import { RootState } from '../../../store';

export const getLessonSelector = (state: RootState) => state.lesson.lesson;
export const getLoadingLessonSelector = (state: RootState) =>
  state.lesson.isLoading;
export const getIsVideoUploadingLessonSelector = (state: RootState) =>
  state.lesson.isVideoUploading;
export const getLessonErrorsSelector = (state: RootState) =>
  state.lesson.errors;
